import React from 'react'
import { Skeleton } from '@mui/material'

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import {
    pageTypeColumn, reachColumn, numBrandsColumn, infoColumn, imageBannerColumn, dateColumn, retailerColumn,
    productCategoryColumn, positionColumn, visibilityColumn, companyBrandColumn, tagColumn
} from "./columns"
import {useBannersDetailsFilters} from "../@hooks";


export default function BannersDetailsTable() {

    const { data } = useBannersDetailsFilters()
    const { showToast } = useToast()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        dateColumn(),
        retailerColumn(),
        ...companyBrandColumn(),
        pageTypeColumn(),
        productCategoryColumn(),
        ...tagColumn(),
        imageBannerColumn(),
        ...reachColumn(),
        positionColumn(),
        ...infoColumn(),
        ...visibilityColumn(),
        numBrandsColumn(),
    ]

    return <AppTableSeeker
        data={data}
        title={ <TitleWithPopover title="Banners Details" />}
        columns={columns}
        options={{
            onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.BANNERS}/details/wrapped/excel`),
        }}
    />
}
